import { render, staticRenderFns } from "./donor-organization.vue?vue&type=template&id=b34a4228&scoped=true&"
import script from "./donor-organization.vue?vue&type=script&lang=js&"
export * from "./donor-organization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b34a4228",
  null
  
)

export default component.exports